import React from 'react';
import { Card, Segmented, Button, Tooltip } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const navOptions = [
  { label: 'Try Before You Buy', value: 'try', path: '/ai-tryout-studio/try' },
  { label: 'Swatches / Overlays', value: 'swatches-v2', path: '/ai-tryout-studio/swatches-v2' },
  { label: 'User Gallery', value: 'gallery', path: '/ai-tryout-studio/gallery' },
  { label: 'Settings', value: 'settings', path: '/ai-tryout-studio/settings' },
];

const renderLabel = (text) => (
  <span style={{ display: 'block', whiteSpace: 'normal', lineHeight: 1.2 }}>{text}</span>
);

const ModuleNav = ({ activeKey }) => {
  const navigate = useNavigate();
  const isNavKey = navOptions.some((option) => option.value === activeKey);
  const currentValue = isNavKey ? activeKey : navOptions[0].value;

  return (
    <Card className="mb-4 shadow-sm" bodyStyle={{ padding: '16px 24px' }}>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
        <Segmented
          block
          value={currentValue}
          options={navOptions.map(({ label, value }) => ({ label: renderLabel(label), value }))}
          onChange={(value) => {
            const target = navOptions.find((item) => item.value === value);
            if (target) {
              navigate(target.path);
            }
          }}
          size="large"
          style={{ minWidth: 260 }}
        />
        <Tooltip title="Open Ai Tryout Studio settings">
          <Button
            type="text"
            icon={<SettingOutlined />}
            onClick={() => navigate('/ai-tryout-studio/settings')}
          >
            Settings
          </Button>
        </Tooltip>
      </div>
    </Card>
  );
};

export default ModuleNav;

